import _ from "lodash";
import * as moment from "moment";

const roundToIntervalEnd = (timestamp, intervalInMinutes) => {
  const duration = moment.duration(intervalInMinutes, "minutes").asSeconds();
  return Math.floor((timestamp + duration) / duration) * duration;
};

export const groupByInterval = (data, intervalInMinutes, fator = 1, method) => {
  if (!Array.isArray(data) || data.length === 0) return data;
  const groupData = (array) => {
    return _.chain(array)
      .groupBy((item) =>
        roundToIntervalEnd(parseInt(item.clock), intervalInMinutes),
      )
      .map((values, key) => {
        let finalValue;
        const numericValues = values.map((item) =>
          parseFloat(item?.value || 0),
        );

        switch (method) {
          case "max":
            finalValue = _.max(numericValues);
            break;
          case "min":
            finalValue = _.min(numericValues);
            break;
          case "avg":
            finalValue = _.mean(numericValues);
            break;
          case "sum":
          default:
            finalValue = _.sum(numericValues) / (intervalInMinutes * fator);
            break;
        }

        return {
          clock: parseInt(key),
          value: finalValue,
        };
      })
      .value();
  };

  return groupData(data);
};
